import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "asset-stats-grid"
}
const _hoisted_2 = { class: "asset-stat-header" }
const _hoisted_3 = { class: "asset-stat-value" }
const _hoisted_4 = {
  key: 1,
  class: "modbus-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.items.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.key,
            class: "asset-stat"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-activity" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(item.label), 1)
            ]),
            _createElementVNode("div", _hoisted_3, _toDisplayString(item.value), 1)
          ]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "bi bi-plug" }, null, -1),
        _createElementVNode("span", null, "Brak danych modbus", -1)
      ]))]))
}